import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { useTracker } from '../../../context/hooks';
import { SeoRecommendations } from '../../constants';
import { RecommendationBaseView } from '../../sharedComponents/RecommendationBaseView';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const AddMetaDescriptionKBLink = () => {
  const {
    track
  } = useTracker();
  const handleClickKBLink = event => {
    track('clickedLearnMoreLink', {
      recommendationType: SeoRecommendations.ADD_META_DESCRIPTION,
      linkAddress: event.currentTarget.href
    });
  };
  return /*#__PURE__*/_jsx(Link, {
    href: "https://blog.hubspot.com/marketing/how-to-write-a-meta-description",
    external: true,
    onClick: handleClickKBLink,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.linkText.ADD_META_DESCRIPTION"
    })
  });
};
export const AddMetaDescriptionView = ({
  auditResult,
  editorApi
}) => {
  const {
    track
  } = useTracker();
  const handleTrackAction = () => {
    track('clickedFixLink', {
      recommendationType: SeoRecommendations.ADD_META_DESCRIPTION
    });
  };
  return /*#__PURE__*/_jsx(RecommendationBaseView, {
    testId: "add-meta-description-rec",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.ADD_META_DESCRIPTION"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.ADD_META_DESCRIPTION"
    }),
    status: auditResult.status,
    action: editorApi.addMetaDescription,
    actionButtonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.actions.ADD_META_DESCRIPTION"
    }),
    onTrackAction: handleTrackAction,
    children: /*#__PURE__*/_jsx(View, {
      marginInlineStart: "600",
      marginBlockEnd: "200",
      as: "div",
      children: /*#__PURE__*/_jsx(AddMetaDescriptionKBLink, {})
    })
  });
};